import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Switch } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { Card } from "@towersystems/roam-common-native";
import {
  FlatActionList,
  FlatActionListItem,
} from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../../types";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { useLocalSettingsProvider } from "../../../../utilities/local-settings";
import { useTyroIClient } from "../../../../utilities/tyro/hooks";
import { useTranslation } from "../../../../utilities/i18n";

export type TyroSettingsLandingScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "TyroSettingsLandingScreen"
>;

export const TyroSettingsLandingScreen = ({
  route,
  navigation,
}: TyroSettingsLandingScreenProps) => {
  const { t } = useTranslation("settings");
  const isDev = route.params.isDev;
  const { iClient, initialized } = useTyroIClient({
    mode: isDev ? "DEV" : "PROD",
  });
  const { showMessage } = useFlashMessages();
  const {
    setSetting,
    settings: {
      integratedTyroReceiptPrinting,
      useTyroSimulator,
      printMerchantReceipt,
    },
  } = useLocalSettingsProvider();

  let items: FlatActionListItem[] = [];

  if (isDev && initialized) {
    items = [
      ...items,
      {
        key: "logs",
        title: t("action.tyro_logs.label"),
        subTitle: t("action.tyro_logs.description"),
        onPress: () => navigation.navigate("TyroLogsScreen", { isDev: isDev }),
      },
      {
        key: "useTyroSimulator",
        title: t("action.use_simulator.label"),
        subTitle: t("action.use_simulator.description"),
        componentRight: () => {
          return (
            <View>
              <Switch
                value={useTyroSimulator}
                onValueChange={() =>
                  setSetting("useTyroSimulator", !useTyroSimulator)
                }
              />
            </View>
          );
        },
      },
    ];

    if (useTyroSimulator) {
      items.push({
        key: "reset",
        title: t("action.reset_simulator.label"),
        subTitle: t("action.reset_simulator.description"),
        destructive: true,
        onPress: () => {
          iClient?.getConfiguration((config: any) => {
            var url =
              "https://integrationsimulator.test.tyro.com/terminals/" +
              config.mid +
              "/" +
              config.tid +
              "/reset";
            fetch(url).then(() => {
              showMessage({
                message: t("messages.tyro_simulator_reset_success"),
                severity: "success",
              });
            });
          });
        },
      });
    }
  }
  let printItems: FlatActionListItem[] = [
    {
      key: "pair",
      title: t("action.tyro_pair_terminal.label"),
      subTitle: t("action.tyro_pair_terminal.description"),
      onPress: () =>
        navigation.navigate("SetupTyroSettingScreen", { isDev: isDev }),
    },
    {
      key: "integratedTyroReceipts",
      title: t("action.tyro_integrated_receipts.label"),
      subTitle: t("action.tyro_integrated_receipts.description"),
      componentRight: () => {
        return (
          <View>
            <Switch
              value={integratedTyroReceiptPrinting}
              onValueChange={() =>
                setSetting(
                  "integratedTyroReceiptPrinting",
                  !integratedTyroReceiptPrinting
                )
              }
            />
          </View>
        );
      },
    },
  ];

  if (integratedTyroReceiptPrinting) {
    printItems.push({
      key: "printMerchantReceipt",
      title: t("action.tyro_print_merchant_copy.label"),
      subTitle: t("action.tyro_print_merchant_copy.description"),
      componentRight: () => {
        return (
          <View>
            <Switch
              value={printMerchantReceipt}
              onValueChange={() =>
                setSetting("printMerchantReceipt", !printMerchantReceipt)
              }
            />
          </View>
        );
      },
    });
  }

  if (false === isDev && initialized) {
    items.push({
      key: "logs",
      title: t("action.tyro_logs.label"),
      subTitle: t("action.tyro_logs.description"),
      onPress: () => navigation.navigate("TyroLogsScreen", { isDev: false }),
    });
  }

  return (
    <Page title={t("name")}>
      <Card
        title={t("card.tyro_setup.title")}
        containerStyle={{ marginBottom: Spacings.s8 }}
      >
        <FlatActionList items={printItems} />
      </Card>
      {items.length >= 1 ? (
        <Card title={t("card.tyro_developer.title")}>
          <FlatActionList items={items} />
        </Card>
      ) : null}
    </Page>
  );
};
